import React from 'react'
import Widget from './widget'
import Link from '@/components/Common/Link'
import InStockL2Heading from '../../Pages/InStockDetailPageV2/InL2Heading'

export default React.memo(function Blogs({
  heading,
  collection,
}: {
  heading: string
  collection?: {
    title: string
    published_at: string
    img_url: string
    navlink: string
  }[]
}) {
  if (!heading) {
    return null
  }
  return (
    <div>
      {heading && <InStockL2Heading heading={heading} />}
      <div>
        {collection?.map((item, idx) => (
          <Link
            href={item.navlink}
            openInNewTab
            key={`collection${idx}`}
            title={item.title}
          >
            <Widget {...item} isBorder={idx !== collection.length - 1} />
          </Link>
        ))}
      </div>
    </div>
  )
})
